import React from "react";

const ServiceProcessSteps = ({ heading, introduction, items = [] }) => {
  if (!items.length) {
    return null;
  }

  return (
    <div>
      {(heading || introduction) && (
        <div className="mb-8 sm:mb-10 max-w-3xl">
          {heading && (
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3">
              {heading}
            </h2>
          )}
          {introduction && (
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
              {introduction}
            </p>
          )}
        </div>
      )}
      <div className="flex flex-col sm:flex-row sm:items-stretch gap-3 sm:gap-0">
        {items.map((step, index) => (
          <React.Fragment key={step.label || index}>
            <div className="flex-1 bg-gray-50 border border-gray-200 rounded-lg p-4 sm:p-5 text-center">
              <div
                className="text-xl sm:text-2xl font-extrabold leading-none"
                style={{ color: "#db0058" }}
              >
                {step.number}
              </div>
              <div className="mt-2 text-sm font-semibold text-gray-900">
                {step.label}
              </div>
              {step.description && (
                <div className="mt-1 text-xs text-gray-600 leading-snug">
                  {step.description}
                </div>
              )}
            </div>
            {index < items.length - 1 && (
              <div
                className="flex items-center justify-center sm:w-7 flex-shrink-0 py-1 sm:py-0"
                style={{ color: "#db0058" }}
                aria-hidden="true"
              >
                <span className="hidden sm:inline text-lg font-bold">&#8594;</span>
                <span className="sm:hidden text-lg font-bold">&#8595;</span>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ServiceProcessSteps;
